module.exports = __webpack_public_path__ + "img/avatar-default.90c05a1e.png";